export default __webpack_public_path__ + "static/media/highlight-5-new.f3bf7cc2.png";